<div class="settings-types-audit">
  <div class="audit-header">
    <a class="audit-back" routerLink="/settings/types">
      <i class="lx-icon lx-arrow-left"></i> Back to Types
    </a>
    <h2>Audit history — {{ settingName }}</h2>
  </div>

  <div class="settings__data">
    <ag-grid-angular
      #grid
      class="ag-theme-alpine ag-grid-sticky-header"
      domLayout="autoHeight"
      style="width: 100%; height: 100%"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [enableCellTextSelection]="true"
      [ensureDomOrder]="true"
      [enableBrowserTooltips]="true"
      (gridReady)="onGridReady($event)"></ag-grid-angular>
  </div>
</div>
